import { render, staticRenderFns } from "./CheckQuestionRow.vue?vue&type=template&id=79964606"
import script from "./CheckQuestionRow.vue?vue&type=script&lang=js"
export * from "./CheckQuestionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports